import "./index.scss";
import { CheckoutCopyright } from "components/UI/atoms";
import {
  CheckoutCouponDiscount,
  CheckoutSubmit,
  CheckoutSummaryOrder,
  CheckoutSummaryTable
} from "components/UI/molecules";
import { INTERNAL_PATHS } from "routes/paths";
import { useNavigate } from "hooks/useCustomNavigation";
import { useState } from "react";

export const CheckoutSummary = () => {
  const [isCouponAreaOpen, setIsCouponAreaOpen] = useState(false);
  const navigate = useNavigate();

  const closeCouponArea = () => setIsCouponAreaOpen(false);

  return (
    <div className="checkout-summary">
      <div className="header-summary">
        <h2 className="summary-title">Order Summary</h2>
        <button
          onClick={() => navigate(INTERNAL_PATHS.CART)}
          className="edit-cart"
        >
          Edit
        </button>
      </div>
      <CheckoutSummaryTable />
      <CheckoutCouponDiscount
        isCouponAreaOpen={isCouponAreaOpen}
        setIsCouponAreaOpen={setIsCouponAreaOpen}
      />
      <CheckoutSummaryOrder closeCouponArea={closeCouponArea} />
      <CheckoutSubmit />
      <CheckoutCopyright customClassName="checkout-copyright-mobile" />
    </div>
  );
};
